import type { ThemeMode } from '../theming';

/**
 * Board colour palette for one appearance theme (BR-61). The shape mirrors the
 * legacy puzzle `Theme` so it feeds the existing `puzzle.applyTheme(theme)`
 * surface unchanged; only the values are theme-driven now.
 *
 * The exact hexes carry a [DESIGNER REVIEW] flag — the mat (`background`) is
 * re-tinted per theme while the fills/grid/hints keep the legacy, legibility-
 * proven values. See the U008 plan "as-built corrections register" item 2.
 */
export interface BoardPalette {
  board: {
    background: string;
    darkFill: string;
    lightFill: string;
    grid: {
      primary: string;
      secondary: string;
      highlighted: string;
    };
  };
  hints: {
    suggestion: string;
    error: string;
  };
}

export const BOARD_PALETTES: Record<ThemeMode, BoardPalette> = {
  blue: {
    board: {
      background: '#46627f', /* pinned: proposed [DESIGNER REVIEW] */
      darkFill: '#333333',
      lightFill: '#d5d5d5',
      grid: {
        primary: '#FFFFFF',
        secondary: '#e6e6e6',
        highlighted: '#4ED600',
      },
    },
    hints: {
      suggestion: '#00ff00',
      error: '#ff0000',
    },
  },
  sand: {
    board: {
      background: '#8a7a5e', /* pinned: proposed [DESIGNER REVIEW] */
      darkFill: '#333333',
      lightFill: '#d5d5d5',
      grid: {
        primary: '#FFFFFF',
        secondary: '#e6e6e6',
        highlighted: '#4ED600',
      },
    },
    hints: {
      suggestion: '#00ff00',
      error: '#ff0000',
    },
  },
  slate: {
    board: {
      background: '#5f666f', /* pinned: proposed [DESIGNER REVIEW] */
      darkFill: '#333333',
      lightFill: '#d5d5d5',
      grid: {
        primary: '#FFFFFF',
        secondary: '#e6e6e6',
        highlighted: '#4ED600',
      },
    },
    hints: {
      suggestion: '#00ff00',
      error: '#ff0000',
    },
  },
};

/** Select the board palette for a theme mode (pure, total over ThemeMode). */
export function paletteForTheme(mode: ThemeMode): BoardPalette {
  return BOARD_PALETTES[mode];
}
